module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.file.name) ? _c('div', {
    staticClass: "tile tile-centered"
  }, [_c('div', {
    staticClass: "tile-icon"
  }, [(_vm.file.accepted) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Approved")]) : _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v("Pending approval")])]), _vm._v(" "), _c('div', {
    staticClass: "tile-content"
  }, [_c('p', {
    staticClass: "tile-title"
  }, [_vm._v(_vm._s(_vm.file.name))]), _vm._v(" "), (_vm.error) ? _c('label', {
    staticClass: "label label-error"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tile-action"
  }, [_c('button', {
    staticClass: "btn",
    class: {
      loading: _vm.saving
    },
    on: {
      "click": _vm.del
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e51a86c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/documents/fileItem.vue
// module id = 524
// module chunks = 1